"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HierarchyDefaultNode;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HierarchyDefaultNode(_ref) {
  var node = _ref.node;

  return _react2.default.createElement("circle", { cx: node.x, cy: node.y, r: 15, fill: "#21D4FD" });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/hierarchy/build/HierarchyDefaultNode.js
// module id = 151
// module chunks = 0